'use strict';

const Item = require('../Item');

/**
 * @class
 * @hideconstructor
 * @extends HomeyAPIV3.Item
 * @memberof HomeyAPIV3.ManagerFlow
 */
class FlowCard extends Item {

  static transformGet(item) {
    item = super.transformGet(item);

    delete item.ownerName; // Prepare for back-end change

    return item;
  }

}

module.exports = FlowCard;
